jQuery(document).ready(function () {
    jQuery(".fancybox").fancybox({
        toolbar  : false,
        smallBtn : true,
        infobar: false,
        arrows:false,
        iframe : {
            preload : true,
        },
        buttons:[
            "thumbs",
        ],
    });

    jQuery(".ap-gallery-zoom").fancybox({
        toolbar  : true,
        smallBtn : false,
        buttons:[
            'close',
        ],
        thumbs : {
            autoStart : true,
            axis      : 'x',
        },
        iframe : {
            preload : true,
        },
        btnTpl: {
            // Arrows
            arrowLeft:
                '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" href="javascript:;">' +
                '<button type="button" class="fancybox_button_next"></button>' +
                "</a>",

            arrowRight:
                '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" href="javascript:;">' +
                '<button type="button" class="fancybox_button_prev"></button>' +
                "</a>",
        },
    });
});
